import { render, staticRenderFns } from "./propose.vue?vue&type=template&id=a6781f9e&scoped=true&"
import script from "./propose.vue?vue&type=script&lang=js&"
export * from "./propose.vue?vue&type=script&lang=js&"
import style0 from "./propose.vue?vue&type=style&index=0&id=a6781f9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6781f9e",
  null
  
)

export default component.exports